import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const fbbTableSummary = () => ({
	subheader: {
		marginLeft: 8,
		display: 'flex',
		alignSelf: 'center',
	},
	header: {
		padding: '5px 16px 3px',
		backgroundColor: '#323232',
		borderRadius: '8px 8px 0 0',
		display: 'flex',
	},
	content: {
		backgroundColor: '#f5f5f5',
		borderRadius: '0 0 8px 8px',
		padding: '10px 16px 13px',
	},
	additionalServices: {
		marginTop: 4,
		paddingTop: 8,
		borderTop: `1px solid ${blackColors[4]}`,
	},
	additionalService: {
		display: 'flex',
	},
	serviceName: {
		flex: 1,
	},
	servicePrice: {
		flex: 1,
		textAlign: 'right',
	},
	summaryContainer: {
		display: 'flex',
	},
	summary: {
		flex: 1,
	},
	buttonsContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	flex: {
		display: 'flex',
	},
	flex1: {
		flex: 1,
	},
	alignEnd: {
		display: 'flex',
		alignItems: 'end',
	},
	alignRight: {
		textAlign: 'right',
	},
	servicesHeader: {
		marginBottom: 7,
	},
	monthlyCost: {
		paddingTop: 4,
		marginTop: 6,
		borderTop: `1px solid ${blackColors[4]}`,
	},
});

export default fbbTableSummary;
